import { render } from "./AutoLogin.vue?vue&type=template&id=06492222"
const script = {}

import exportComponent from "C:\\Program Files\\Jenkins\\.jenkins\\workspace\\Статистика приема\\Univeris.AdmissionStatistics.Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__